// Module
var code = `<div class="external-app"> <iframe class="external-app-frame"></iframe> </div>`;
// Exports
export default code;